import requests from '../../request'


export function getScanOutboundOrder(orderId) {
  return requests({
    method: 'get',
    url: `/order/retail/selfMachine/data/${orderId}`,
  })
}


export function scanOutboundPay(data) {
  return requests({
    method: 'post',
    url: '/order/retail/scanOutbound/pay',
    data,
  })
}

/** 选择商品后创建自助机待支付订单，出参 sheetId 即 orderId */
export function createSelfMachineOrder(data) {
  return requests({
    method: 'post',
    url: '/order/retail/selfMachine',
    data,
  })
}

/** 放弃未支付的自助机订单（选择商品出库返回时关单） */
export function cancelSelfMachineOrder(orderId) {
  return requests({
    method: 'get',
    url: `/order/retail/cancel/${orderId}`,
  })
}
